/*
 * Copyright Red Hat, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { TranslationFunction } from '@backstage/core-plugin-api/alpha';

import { lightspeedTranslationRef } from '../translations/ref';

type TranslateFn = TranslationFunction<typeof lightspeedTranslationRef.T>;

export const formatUpdatedLabel = (updatedAt: string, t: TranslateFn) => {
  const updatedDate = new Date(updatedAt);
  if (Number.isNaN(updatedDate.getTime())) {
    return updatedAt;
  }
  const now = new Date();
  const diffMs = now.getTime() - updatedDate.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (diffDays <= 0) {
    return t('notebooks.updated.today');
  }
  if (diffDays === 1) {
    return t('notebooks.updated.yesterday');
  }
  if (diffDays < 7) {
    return t('notebooks.updated.days', { days: diffDays } as any);
  }
  return `${t('notebooks.updated.on')} ${updatedDate.toLocaleDateString(
    undefined,
    { month: 'short', day: 'numeric' },
  )}`;
};
